type GTagFunction = (...args: any[]) => void;

declare global {
  interface Window {
    gtag?: GTagFunction;
    dataLayer?: any[];
  }
}

// src/utils/ga.ts
export const initGA = () => {
  if (!window.gtag) {
    const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '';
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script1);

    script1.onload = () => {
      window.dataLayer = window.dataLayer || [];
      const gtag = (...args: any[]) => {
        window.dataLayer!.push(args);
      };

      window.gtag = gtag;

      gtag('js', new Date());
      gtag('config', gaId);
    };
  }
};
